module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044792_Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "source"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044792_Sources"
    }
  }, [_c('i', [_vm._v("A Note on Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "abbrev"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044792_Abbreviations"
    }
  }, [_c('i', [_vm._v("List of Abbreviations and Short Names")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044792_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044792_Chapter_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Tensed Urban Visions: Making Bucharest into a Socialist Capital")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044792_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Matters of State: Archaeology, Materiality, and State Making")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044792_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Time-Traveling Houses and Histories Made Invisible")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044792_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Lipstick and Lined Pockets: Strategic Devaluation and Postsocialist Wealth")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044792_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "spacec"
  }, [_vm._v("Displacements: Property, Privatization, and Precarity in a Europeanizing City")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044792_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044792_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253044792_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-678b448a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253044792_Contents.vue
// module id = 75
// module chunks = 0